import { render, staticRenderFns } from "./navbars.vue?vue&type=template&id=2052f9e3&scoped=true"
import script from "./navbars.vue?vue&type=script&lang=js"
export * from "./navbars.vue?vue&type=script&lang=js"
import style0 from "./navbars.vue?vue&type=style&index=0&id=2052f9e3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2052f9e3",
  null
  
)

export default component.exports